import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import taTranslation from './locales/ta/translation.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  ta: {
    translation: taTranslation,
  },
};

// Check for language parameter in URL
const urlParams = new URLSearchParams(window.location.search);
const langFromUrl = urlParams.get('lang');

// If language is in URL, save it to localStorage
if (langFromUrl && (langFromUrl === 'en' || langFromUrl === 'ta')) {
  localStorage.setItem('language', langFromUrl);
}

// Get language from localStorage or use default
const initialLanguage = localStorage.getItem('language') || 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // English as default
    lng: initialLanguage,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
  });

export default i18n;